
export enum SettingsMutationTypes {
  CHANGE_SETTING = 'CHANGE_SETTING',
}
